import { notNullish } from '@paragon/utilities';

export default function assertNotNullish<T>(value: T | undefined | null): value is T {
  if (value == null) console.warn('Value was not expected to be null or undefined.');
  return notNullish(value);
}
